export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.corporate': 'Corporate',
  'nav.collections': 'Collections',
  'nav.documents': 'Our Documents',
  'nav.sales': 'Sales',
  'nav.contact': 'Contact',
  'nav.hr': 'Human Resources',
  'nav.dealerLogin': 'Dealer Login',
  'nav.dealerApplication': 'Dealer Application',
  'nav.search': 'Search carpets...',
  'nav.dayMode': 'Day Mode',
  'nav.nightMode': 'Night Mode',

  // Quick Menu
  'quickMenu.title': 'Quick Menu',
  'quickMenu.subtitle': 'MONS HALI Carpet',
  'quickMenu.language': 'Language',
  'quickMenu.collections': 'Collections',
  'quickMenu.dealerLogin': 'Dealer Login',
  'quickMenu.dealerLoginDesc': 'Access dealer panel',
  'quickMenu.contact': 'Contact',
  'quickMenu.kvkk': 'KVKK & Documents',
  'quickMenu.whatsapp': 'WhatsApp',
  'quickMenu.whatsappDesc': 'Send message',
  'quickMenu.call': 'Call',
  'quickMenu.callDesc': 'Call now',

  // Top Banner
  'topBanner.quality': '✓ Quality Assurance',
  'topBanner.production': '✓ World-Class Production',
  'topBanner.design': '✓ Modern Designs',
  'topBanner.experience': '✓ 30 Years of Experience',
  'topBanner.certified': '✓ ISO 9001 Certified',

  // Corporate Submenu
  'corporate.history': 'History',
  'corporate.visionMission': 'Vision & Mission',
  'corporate.regions': 'Our Regions',
  'corporate.certificates': 'Our Certificates',
  'corporate.eCatalog': 'E-Catalog',
  'corporate.productionProcess': 'Production Process',
  'corporate.wholesaleCarpet': 'Wholesale Carpet Production',
  'corporate.blogNews': 'Blog & News',
  'corporate.gaziantepCarpet': 'Gaziantep Carpet',

  // Collections Grid
  'collectionsGrid.title': 'Our Collections',
  'collectionsGrid.subtitle': '10 Special Categories',
  'collectionsGrid.viewAll': 'View All',
  'collectionsGrid.wholesaleCarpet': 'Wholesale Carpet',
  'collectionsGrid.wholesaleBadge': 'Wholesale Carpet',
  'collectionsGrid.products': 'products',
  'collectionsGrid.page': 'Page',
  'collectionsGrid.notFound': 'Product Not Found',
  'collectionsGrid.notFoundDesc': 'No products found in this category yet.',
  'collectionsGrid.showAll': 'Show All Products',
  'collectionsGrid.exploreAll': 'Explore All Collections',
  'collectionsGrid.category.all': 'All',
  'collectionsGrid.category.modern': 'Wholesale Carpet',
  'collectionsGrid.category.classic': 'Wholesale Carpet',
  'collectionsGrid.category.minimalist': 'Wholesale Carpet',
  'collectionsGrid.category.bohemian': 'Wholesale Carpet',
  'collectionsGrid.category.geometric': 'Wholesale Carpet',
  'collectionsGrid.category.natural': 'Wholesale Carpet',
  'collectionsGrid.category.luxury': 'Wholesale Carpet',
  'collectionsGrid.category.vintage': 'Wholesale Carpet',
  'collectionsGrid.category.ethnic': 'Wholesale Carpet',
  'collectionsGrid.category.kids': 'Wholesale Carpet',

  // Collections Categories
  'collections.categories': 'Categories',
  'collections.bella': 'Bella',
  'collections.sensitive': 'Sensitive',
  'collections.craft': 'Craft',
  'collections.pretty': 'Pretty',
  'collections.balmoral': 'Balmoral',
  'collections.barbados': 'Barbados',
  'collections.calverts': 'Calverts',
  'collections.hamptons': 'Hamptons',
  'collections.heavenlyTwist': 'Heavenly Twist',
  'collections.pashmina': 'Pashmina',
  'collections.saratoga': 'Saratoga',
  'collections.selina': 'Selina',
  'collections.serenade': 'Serenade',
  'collections.softJasmine': 'Soft Jasmine',
  'collections.softSupreme': 'Soft Supreme',
  'collections.sweetDreams': 'Sweet Dreams',
  'collections.olympus': 'Olympus',

  // Factory Gallery
  'factoryGallery.title': 'Our Production Facility',
  'factoryGallery.subtitle': 'Moments from our factory where modern technology and skilled hands come together',

  // Customer Gallery (Carpet Combinations)
  'customerGallery.title': 'Our Carpet Combinations',
  'customerGallery.subtitle': 'Inspiring Spaces',
  'customerGallery.description': 'Discover the unique atmosphere our carpets create in different spaces',
  'customerGallery.newCollection': 'New Collection',
  'customerGallery.catalogButton': '2026 CATALOG',
  'customerGallery.catalogDesc': 'Discover our new collection • 10 pages',

  // Social Responsibility
  'socialResponsibility.title': 'Social Responsibility',
  'socialResponsibility.subtitle': 'Steps we take for a sustainable future',
  'socialResponsibility.goToCollections': 'Go to Collections',
  'socialResponsibility.slide1Title': 'Production for a Green Future',
  'socialResponsibility.slide1Desc': 'We minimize our carbon footprint through eco-friendly production processes and produce carpets using sustainable raw materials.',
  'socialResponsibility.slide2Title': 'We Add Value to Society',
  'socialResponsibility.slide2Desc': 'We carry out social responsibility projects across a wide spectrum from education to health, from culture to arts.',
  'socialResponsibility.slide3Title': 'Sustainable Raw Materials',
  'socialResponsibility.slide3Desc': 'We use recycled yarns and organic fibers, pioneering the conservation of natural resources.',

  // Blog Section
  'blogSection.title': 'Blog & News',
  'blogSection.subtitle': 'Current news and articles from the textile world',
  'blogSection.readMore': 'Read More',
  'blogSection.allPosts': 'All Blog Posts',

  // Global Impact
  'globalImpact.title': 'Worldwide Service',
  'globalImpact.subtitle': 'Global Corporate Impact',
  'globalImpact.exportCountries': 'Export Countries',
  'globalImpact.annualShipments': 'Annual Shipments',
  'globalImpact.continents': 'Continents Reached',
  'globalImpact.carpetExport': 'm² Carpet Export',
  'globalImpact.description': 'Exporting quality carpet production from Gaziantep to the world. We serve in more than 50 countries with our strong business partnerships in Europe, Middle East, Asia and Africa.',
  'globalImpact.country.germany': 'Germany',
  'globalImpact.country.france': 'France',
  'globalImpact.country.uk': 'United Kingdom',
  'globalImpact.country.italy': 'Italy',
  'globalImpact.country.spain': 'Spain',
  'globalImpact.country.netherlands': 'Netherlands',
  'globalImpact.country.belgium': 'Belgium',
  'globalImpact.country.poland': 'Poland',
  'globalImpact.country.uae': 'UAE',
  'globalImpact.country.saudiArabia': 'Saudi Arabia',
  'globalImpact.country.qatar': 'Qatar',
  'globalImpact.country.kuwait': 'Kuwait',
  'globalImpact.country.oman': 'Oman',
  'globalImpact.country.bahrain': 'Bahrain',
  'globalImpact.country.jordan': 'Jordan',
  'globalImpact.country.lebanon': 'Lebanon',
  'globalImpact.country.china': 'China',
  'globalImpact.country.japan': 'Japan',
  'globalImpact.country.southKorea': 'South Korea',
  'globalImpact.country.singapore': 'Singapore',
  'globalImpact.country.malaysia': 'Malaysia',
  'globalImpact.country.thailand': 'Thailand',
  'globalImpact.country.egypt': 'Egypt',
  'globalImpact.country.southAfrica': 'South Africa',
  'globalImpact.country.morocco': 'Morocco',
  'globalImpact.country.tunisia': 'Tunisia',

  // Hero Slider
  'heroSlider.exploreCollections': 'Explore Collections',
  'heroSlider.discoverCollection': 'Discover Collection',

  // Dealer Banner
  'dealerBanner.title': 'Join Our Dealer Network',
  'dealerBanner.subtitle': "Turkey's Most Prestigious",
  'dealerBanner.subtitle2': 'Carpet Dealer Network',
  'dealerBanner.description': 'Grow your business with our premium collections. Benefit from exclusive dealer prices, marketing support and privileged services.',
  'dealerBanner.cardSubtitle': 'Login or register now',
  'dealerBanner.activeDealers': 'Active Dealers',
  'dealerBanner.cityReach': 'City Reach',
  'dealerBanner.profitMargin': 'Profit Margin',
  'dealerBanner.dealerPortal': 'Dealer Portal',
  'dealerBanner.dealerLogin': 'Dealer Login',
  'dealerBanner.createAccount': 'Create Dealer Account',
  'dealerBanner.secureLogin': 'Secure Login',
  'dealerBanner.support247': '24/7 Support',

  // Dealer Float
  'dealerFloat.intro': 'INTRODUCTION',
  'dealerFloat.login': 'DEALER LOGIN',
  'dealerFloat.likes': 'LIKES',
  'dealerFloat.dealerPortal': 'Dealer Portal',
  'dealerFloat.username': 'Username',
  'dealerFloat.password': 'Password',
  'dealerFloat.rememberMe': 'Remember Me',
  'dealerFloat.forgotPassword': 'Forgot Password?',
  'dealerFloat.loginButton': 'Login',
  'dealerFloat.noAccount': "Don't have an account?",
  'dealerFloat.register': 'Register',
  'dealerFloat.registerTitle': 'Dealer Registration',
  'dealerFloat.companyName': 'Company Name',
  'dealerFloat.authorizedName': 'Authorized Person Name',
  'dealerFloat.email': 'Email Address',
  'dealerFloat.phone': 'Phone',
  'dealerFloat.city': 'City',
  'dealerFloat.address': 'Address',
  'dealerFloat.taxOffice': 'Tax Office',
  'dealerFloat.taxNumber': 'Tax Number',
  'dealerFloat.registerButton': 'Complete Registration',
  'dealerFloat.haveAccount': 'Already have an account?',
  'dealerFloat.loginLink': 'Login',
  'dealerFloat.successMessage': 'Your registration has been successfully completed!',

  // Contact Float
  'contactFloat.whatsapp': 'WhatsApp',
  'contactFloat.phone': 'Phone',
  'contactFloat.email': 'Email',
  'contactFloat.location': 'Location',
  'contactFloat.message': 'Message',
  'contactFloat.dealerLogin': 'Dealer Login',
  'contactFloat.sendMessage': 'Send Message',
  'contactFloat.yourName': 'Your Name',
  'contactFloat.yourEmail': 'Your Email',
  'contactFloat.yourPhone': 'Your Phone',
  'contactFloat.yourMessage': 'Your Message',
  'contactFloat.send': 'Send',

  // Contact Page
  'contact.title': 'Contact',
  'contact.subtitle': 'Get in touch with us',
  'contact.heroSubtitle': 'Get in touch with us, we would be happy to help you',
  'contact.info': 'Contact Information',
  'contact.address': 'Address',
  'contact.addressValue': 'Organized Industrial Zone, 5th Street No: 42, Gaziantep, Turkey',
  'contact.phone': 'Phone',
  'contact.email': 'Email',
  'contact.workingHours': 'Working Hours',
  'contact.workingHoursValue': 'Monday - Friday: 08:00 - 18:00',
  'contact.visitUs': 'Visit Us',
  'contact.visitUsDesc': 'You can make an appointment to visit our factory and showroom.',
  'contact.mapTitle': 'Location Map',
  'contact.form.title': 'Send Us a Message',
  'contact.form.reachUs': 'Reach Us',
  'contact.form.reachUsDesc': 'Fill out the form for your questions, suggestions or business proposals, and we will get back to you as soon as possible.',
  'contact.form.name': 'Full Name',
  'contact.form.namePlaceholder': 'Your first and last name',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'example@email.com',
  'contact.form.phone': 'Phone',
  'contact.form.phonePlaceholder': '+90 5XX XXX XX XX',
  'contact.form.subject': 'Subject',
  'contact.form.subjectPlaceholder': 'Select a subject',
  'contact.form.subject.general': 'General Information',
  'contact.form.subject.product': 'Product Information',
  'contact.form.subject.dealer': 'Dealership',
  'contact.form.subject.sales': 'Sales',
  'contact.form.subject.support': 'Technical Support',
  'contact.form.message': 'Your Message',
  'contact.form.messagePlaceholder': 'Write your message here... (Maximum 500 characters)',
  'contact.form.send': 'Send',
  'contact.form.success': 'Your message has been sent successfully.',

  // Footer
  'footer.quickLinks': 'Quick Links',
  'footer.corporate': 'Corporate',
  'footer.collections': 'Collections',
  'footer.contact': 'Contact',
  'footer.followUs': 'Follow Us',
  'footer.newsletter': 'Newsletter',
  'footer.newsletterDesc': 'Subscribe to our newsletter to be informed about new products and campaigns.',
  'footer.emailPlaceholder': 'Your email address',
  'footer.subscribe': 'Subscribe',
  'footer.allRightsReserved': 'All rights reserved.',
  'footer.companyName': '2026 Wholesale Carpet Factory.',
  'footer.poweredBy': 'Powered by software',
  'footer.seoLinks.title': 'Popular Carpet Categories',
  'footer.seoLinks.wholesaleCarpet': 'Wholesale Carpet Sales',
  'footer.seoLinks.modernCarpet': 'Modern Carpet',
  'footer.seoLinks.luxuryCarpet': 'Luxury Carpet',
  'footer.seoLinks.carpetExport': 'Carpet Export',
  'footer.seoLinks.carpetProduction': 'Carpet Production',
  'footer.seoLinks.handwovenCarpet': 'Handwoven Carpet',
  'footer.seoLinks.carpetDealer': 'Carpet Dealership',
  'footer.seoLinks.turkishCarpet': 'Turkish Carpet',
  'footer.seoLinks.carpetFair': 'Carpet Fairs',
  'footer.seoLinks.qualityCarpet': 'Quality Carpet',
  'footer.seoLinks.hotelCarpet': 'Hotel Carpet',
  'footer.seoLinks.vintageCarpet': 'Vintage Carpet',
  'footer.seoLinks.carpetWholesale': 'Carpet Wholesale',
  'footer.seoLinks.ecoCarpet': 'Eco-Friendly Carpet',
  'footer.seoLinks.carpetFactory': 'Carpet Factory',

  // Welcome Popup
  'popup.welcome': 'Welcome to MONS HALI',
  'popup.description': 'Discover quality and elegance in carpet production. Explore our collections and find the carpet of your dreams.',
  'popup.explore': 'Explore Collections',
  'popup.close': 'Close',

  // Home Page
  'home.hero.title': 'Quality and Elegance in Carpet Production',
  'home.hero.subtitle': 'Discover our collections that add value to your living spaces with modern designs and superior quality.',
  'home.hero.cta': 'Explore Collections',
  'home.hero.contact': 'Contact Us',

  'home.welcome.title': 'Welcome to MONS HALI',
  'home.welcome.description': 'As MONS HALI, we have been producing quality carpets for years. We offer the best products to our customers with our modern production facilities and expert team.',
  'home.welcome.learnMore': 'Learn More',

  'home.collections.title': 'Our Collections',
  'home.collections.subtitle': 'Discover our special collections',
  'home.collections.viewAll': 'View All',

  'home.certificates.title': 'Our Certificates',
  'home.certificates.subtitle': 'Quality and trust documents',

  'home.factory.title': 'Our Factory',
  'home.factory.subtitle': 'Modern production facilities',

  'home.customers.title': 'Our Customers',
  'home.customers.subtitle': 'Brands that trust us',

  'home.social.title': 'Social Responsibility',
  'home.social.subtitle': 'Our projects for society',

  'home.blog.title': 'Blog',
  'home.blog.subtitle': 'Latest news and articles',
  'home.blog.readMore': 'Read More',

  // Dealer Login Page
  'dealer.login.title': 'Dealer Login',
  'dealer.login.subtitle': 'Login to access the dealer panel',
  'dealer.login.email': 'Email Address',
  'dealer.login.password': 'Password',
  'dealer.login.remember': 'Remember Me',
  'dealer.login.forgot': 'Forgot Password?',
  'dealer.login.button': 'Login',
  'dealer.login.noAccount': "Don't have an account?",
  'dealer.login.apply': 'Apply for Dealership',

  // Dealer Application Page
  'dealer.application.title': 'Dealer Application',
  'dealer.application.subtitle': 'Fill out the form to become a dealer',
  'dealer.application.companyName': 'Company Name',
  'dealer.application.contactPerson': 'Contact Person',
  'dealer.application.email': 'Email Address',
  'dealer.application.phone': 'Phone',
  'dealer.application.address': 'Address',
  'dealer.application.city': 'City',
  'dealer.application.country': 'Country',
  'dealer.application.experience': 'Years of Experience',
  'dealer.application.message': 'Message',
  'dealer.application.submit': 'Submit Application',
  'dealer.application.success': 'Your application has been received. We will contact you soon.',

  // Documents Page
  'documents.title': 'Our Documents',
  'documents.subtitle': 'Our quality certificates and documents',
  'documents.download': 'Download',
  'documents.view': 'View',

  // Collections Page
  'collections.title': 'Our Collections',
  'collections.subtitle': 'Discover our special carpet collections',
  'collections.all': 'All',
  'collections.filter': 'Filter by Category',
  'collections.viewDetails': 'View Details',
  'collections.addToCart': 'Add to Cart',

  // Sales Page
  'sales.title': 'Sales',
  'sales.subtitle': 'Discover our products',
  'sales.featured': 'Featured Products',
  'sales.newArrivals': 'New Arrivals',
  'sales.bestSellers': 'Best Sellers',
  'sales.viewProduct': 'View Product',
  'sales.networkTitle': 'Our Sales Network',
  'sales.networkSubtitle': 'Serving you with over 170 dealers and 4 showrooms across Turkey',
  'sales.totalDealers': 'Total Dealers',
  'sales.cities': 'Cities',
  'sales.showrooms': 'Showrooms',
  'sales.countries': 'Export Countries',
  'sales.regionalNetwork': 'Regional Sales Network',
  'sales.regionalNetworkDesc': 'We are with you with our strong dealer network in 7 regions of Turkey',
  'sales.allRegions': 'All Regions',
  'sales.dealer': 'Dealers',
  'sales.activeCities': 'Active Cities',
  'sales.showroomsTitle': 'Our Showrooms',
  'sales.showroomsDesc': 'Visit our showrooms to see and experience our products in person',
  'sales.getDirections': 'Get Directions',
  'sales.becomeDealer': 'Become Our Dealer',
  'sales.becomeDealerDesc': 'Join the strong dealer network of Turkey\'s leading carpet brand. Grow your business with exclusive benefits and support.',
  'sales.applyNow': 'Apply Now',
  'sales.callUs': 'Call Us',
  'sales.globalReach': 'Global Reach',
  'sales.globalReachDesc': 'As a strong brand exporting to more than 50 countries, we represent quality carpet production worldwide. We work with reliable business partners in Europe, Middle East, Asia and Africa.',
  'sales.europe': 'Europe',
  'sales.middleEast': 'Middle East',
  'sales.asia': 'Asia',
  'sales.africa': 'Africa',
  'sales.exportInquiry': 'Export Inquiry',

  // HR Page
  'hr.title': 'Human Resources',
  'hr.subtitle': 'Join our team',
  'hr.openPositions': 'Open Positions',
  'hr.apply': 'Apply',
  'hr.noPositions': 'There are no open positions at the moment.',
  'hr.form.title': 'Job Application Form',
  'hr.form.fullName': 'Full Name',
  'hr.form.email': 'Email Address',
  'hr.form.phone': 'Phone',
  'hr.form.position': 'Position Applied For',
  'hr.form.cv': 'Upload CV',
  'hr.form.coverLetter': 'Cover Letter',
  'hr.form.submit': 'Submit Application',
  'hr.form.success': 'Your application has been received.',

  // Corporate - History
  'history.title': 'Our History',
  'history.subtitle': 'Our journey from past to present',

  // Corporate - Vision & Mission
  'vision.title': 'Vision & Mission',
  'vision.subtitle': 'Our goals and values',
  'vision.ourVision': 'Our Vision',
  'vision.ourMission': 'Our Mission',
  'vision.ourValues': 'Our Values',

  // Vision Mission Page
  'visionMission.heroTitle': 'Vision & Mission',
  'visionMission.heroSubtitle': 'Our goals and values for the future',
  'visionMission.heroAlt': 'Vision Mission',
  'visionMission.ourVision': 'Our Vision',
  'visionMission.visionImgAlt': 'Vision',
  'visionMission.visionP1': 'To become a pioneering brand in quality, innovation and sustainability in the global carpet industry. To combine Turkish carpet art with modern production techniques and reach the position of the most preferred luxury carpet manufacturer in the global market.',
  'visionMission.visionP2': 'By 2030, we aim to be present in more than 100 countries, reach an annual production capacity of 2 million m², and become the pioneer of sustainable production in the industry.',
  'visionMission.ourMission': 'Our Mission',
  'visionMission.missionImgAlt': 'Mission',
  'visionMission.missionP1': 'To produce world-class luxury carpets by combining the latest technology with traditional craftsmanship. To add value to living spaces by offering products that combine aesthetics, comfort and durability to our customers.',
  'visionMission.missionP2': 'To set an example for the industry with our eco-friendly production processes, ethical business practices and continuous improvement-focused working principles, and to create value for all our stakeholders.',
  'visionMission.ourValues': 'Our Values',
  'visionMission.valuesSubtitle': 'Our core values that shape our working principles and drive us to success',
  'visionMission.value1.title': 'Quality',
  'visionMission.value1.desc': 'We offer excellent products to our customers by maintaining the highest quality standards at every stage of production.',
  'visionMission.value2.title': 'Sustainability',
  'visionMission.value2.desc': 'We invest responsibly in the future with eco-friendly production processes and renewable energy use.',
  'visionMission.value3.title': 'Innovation',
  'visionMission.value3.desc': 'We develop innovative products and production techniques that lead the industry through our R&D activities.',
  'visionMission.value4.title': 'People-Centered',
  'visionMission.value4.desc': 'We create a happy and productive work environment by investing in the development of our employees.',
  'visionMission.value5.title': 'Customer Satisfaction',
  'visionMission.value5.desc': 'We build long-term business partnerships with a service approach that exceeds our customers\' expectations.',
  'visionMission.value6.title': 'Global Vision',
  'visionMission.value6.desc': 'We make our country proud by representing the Turkish carpet industry in the best way in world markets.',

  // Corporate - Regions
  'regions.title': 'Our Regions',
  'regions.subtitle': 'Our service areas',

  // Corporate - Certificates
  'certificates.title': 'Our Certificates',
  'certificates.subtitle': 'Quality and trust documents',

  // Corporate - E-Catalog
  'catalog.title': 'E-Catalog',
  'catalog.subtitle': 'Browse our digital catalog',
  'catalog.download': 'Download Catalog',
  'catalog.view': 'View Online',

  // Common
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
  'common.success': 'Successful',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.viewAll': 'View All',
  'common.learnMore': 'Learn More',
  'common.readMore': 'Read More',
  'common.showMore': 'Show More',
  'common.showLess': 'Show Less',

  // Blog Page
  'blog.heroLabel': '10 New Articles',
  'blog.heroTitle': 'Carpet Industry News',
  'blog.heroSubtitle': '<strong>Wholesale carpet sales</strong>, international fair adventures, export achievements and carpet production trends - the latest news',
  'blog.breadcrumbHome': 'Home',
  'blog.breadcrumbBlog': 'Blog & News',
  'blog.categoryAll': 'All',
  'blog.categoryFair': 'Fair',
  'blog.categoryExport': 'Export',
  'blog.categoryCollection': 'Collection',
  'blog.categorySustainability': 'Sustainability',
  'blog.categoryCampaign': 'Campaign',
  'blog.categoryProduction': 'Production',
  'blog.categoryProject': 'Project',
  'blog.categoryGuide': 'Guide',
  'blog.seoIntro': 'On our blog page covering the pulse of the <strong>wholesale carpet sales</strong> and <strong>carpet export</strong> industry, you can find the latest news about international <strong>carpet fairs</strong>, new collection launches, wholesale carpet sales campaigns and carpet production processes. With over 30 years of experience in the carpet industry, we provide valuable content to wholesale carpet buyers and our dealers.',
  'blog.readMore': 'Read More',
  'blog.readTime': 'read',
  'blog.noPostsInCategory': 'No posts found in this category yet.',
  'blog.share': 'Share:',
  'blog.seoCard1Title': 'International Carpet Fairs',
  'blog.seoCard1Desc': 'We expand our wholesale carpet sales network by participating in the world\'s most prestigious <strong>carpet fairs</strong> such as Milano, Paris, and High Point.',
  'blog.seoCard2Title': 'Carpet Export',
  'blog.seoCard2Desc': 'We represent the power of the Turkish carpet industry in the world market by <strong>wholesale carpet export</strong> to 25+ countries.',
  'blog.seoCard3Title': 'Quality and Certificates',
  'blog.seoCard3Desc': 'In our ISO certified production facilities, we produce carpets at the highest quality standards for <strong>wholesale carpet sales</strong>.',
  'blog.faqTitle': 'Frequently Asked Questions',
  'blog.faq1Q': 'What is the minimum order quantity for wholesale carpet purchases?',
  'blog.faq1A': 'The minimum order quantity for wholesale carpet purchases varies by collection. Please contact our sales team for detailed information.',
  'blog.faq2Q': 'Which countries do you export carpets to?',
  'blog.faq2A': 'We export carpets to more than 50 countries including Europe, Middle East, Asia and Africa. Contact us for delivery conditions specific to your country.',
  'blog.faq3Q': 'Can I get information about your carpet production process?',
  'blog.faq3A': 'In our production facility where modern machines and skilled hands come together, every stage from raw material to final product is carefully controlled.',
  'blog.faq4Q': 'Can I order custom design carpets?',
  'blog.faq4A': 'Yes, we can produce carpets in custom designs and sizes for our corporate clients. Please contact our sales team to share your project details.',

  // Blog Posts
  'blog.post1.title': 'We Took Our Place at Milano Carpet Expo 2026 - New Era in Wholesale Carpet Sales',
  'blog.post1.excerpt': 'Our company attracted attention with wholesale carpet sales and export opportunities at Europe\'s most prestigious carpet fair, Milano Carpet Expo 2026.',
  'blog.post1.date': 'January 18, 2026',
  'blog.post1.readTime': '6 min',
  'blog.post2.title': 'High Point Market 2026: Turkish Carpets Storm in the American Market',
  'blog.post2.excerpt': 'Our wholesale carpet collections received great interest at the world\'s largest furniture and carpet fair, High Point.',
  'blog.post2.date': 'January 12, 2026',
  'blog.post2.readTime': '7 min',
  'blog.post3.title': 'Paris Deco Off 2026: Our Luxury Carpet Designs Enchanted Europe',
  'blog.post3.excerpt': 'We met with wholesale buyers with our modern and classic carpet collections at Paris\'s prestigious design fair.',
  'blog.post3.date': 'January 5, 2026',
  'blog.post3.readTime': '5 min',
  'blog.post4.title': '35 Tons of Carpet Export in 2025 - We Broke the Record!',
  'blog.post4.excerpt': 'Great success in wholesale carpet sales: We reached the highest figure in our company history by exporting 35 tons of carpets to 25 countries.',
  'blog.post4.date': 'December 28, 2025',
  'blog.post4.readTime': '5 min',
  'blog.post5.title': '2026 Spring-Summer Carpet Collection Launched - New Trends',
  'blog.post5.excerpt': 'Our 2026 Spring-Summer collection prepared for wholesale carpet sales stands out with nature-inspired color palettes and modern patterns.',
  'blog.post5.date': 'December 20, 2025',
  'blog.post5.readTime': '6 min',
  'blog.post6.title': 'Sustainable Carpet Production: Our Eco-Friendly Approach',
  'blog.post6.excerpt': 'We contribute to a sustainable future with eco-friendly materials and energy-efficient processes in wholesale carpet production.',
  'blog.post6.date': 'December 15, 2025',
  'blog.post6.readTime': '8 min',
  'blog.post7.title': 'Special Price Advantages for Wholesale Carpet Buyers in 2026',
  'blog.post7.excerpt': 'Our special wholesale carpet sales campaign for 2026 has started. Special discounts for our dealers and wholesale buyers.',
  'blog.post7.date': 'December 10, 2025',
  'blog.post7.readTime': '4 min',
  'blog.post8.title': 'New Techniques and Traditional Art in Handwoven Carpet Production',
  'blog.post8.excerpt': 'We combine traditional handwoven carpet art with modern techniques. Our handwoven collections are receiving great interest in wholesale carpet sales.',
  'blog.post8.date': 'December 5, 2025',
  'blog.post8.readTime': '7 min',
  'blog.post9.title': 'Special Carpet Solutions for Hotel and Restaurant Projects',
  'blog.post9.excerpt': 'We offer special solutions for hotels, restaurants and commercial projects in wholesale carpet sales.',
  'blog.post9.date': 'November 28, 2025',
  'blog.post9.readTime': '6 min',
  'blog.post10.title': 'Carpet Care Guide: Tips for Long-Lasting Use',
  'blog.post10.excerpt': 'We share our carpet care guide for customer satisfaction after wholesale carpet sales.',
  'blog.post10.date': 'November 20, 2025',
  'blog.post10.readTime': '5 min',

  // Wholesale Carpet Production Page
  'wholesale.heroLabel': 'Wholesale Carpet Production & Global Trade',
  'wholesale.heroTitle': 'Wholesale Carpet Production and Global Carpet Trade',
  'wholesale.heroSubtitle': 'As a leading wholesale carpet manufacturer from Gaziantep to the world, we export quality carpets to more than 50 countries. We are your reliable solution partner in the global market as a carpet wholesaler.',
  'wholesale.heroAlt': 'Wholesale Carpet Production Factory',
  'wholesale.ctaContact': 'Contact Us',
  'wholesale.ctaCollections': 'Explore Collections',

  'wholesale.stat1': 'Export Countries',
  'wholesale.stat2': 'm² Annual Production',
  'wholesale.stat3': 'Years of Experience',
  'wholesale.stat4': 'Expert Employees',

  'wholesale.introLabel': 'About Us',
  'wholesale.introTitle': "Turkey's Leading Carpet Wholesaler",
  'wholesale.introP1': 'With over 30 years of experience, MONS HALI is among Turkey\'s most established wholesale carpet manufacturers. At our modern production facilities in Gaziantep, we produce thousands of square meters of carpet daily, providing uninterrupted supply to carpet wholesalers and distributors worldwide.',
  'wholesale.introP2': 'Our wide product range in wholesale carpet sales covers machine-made carpets, handmade carpets, modern designs and classic collections. We create custom solutions for each customer\'s needs and provide flexibility in minimum order quantities.',
  'wholesale.introP3': 'With our ISO 9001 certified production processes, OEKO-TEX compliant raw material usage and strict quality control mechanisms, we stand out as a trusted brand in carpet export.',
  'wholesale.isoCertified': 'Certified Production',

  'wholesale.processLabel': 'Production Process',
  'wholesale.processTitle': 'Wholesale Carpet Production Processes',
  'wholesale.processSubtitle': 'Quality and precision at every stage from raw material to finished product. 5 key processes applied in our wholesale carpet production.',
  'wholesale.processBannerTitle': 'End-to-End Production Control',
  'wholesale.processBannerDesc': 'Every stage from raw material selection to packaging is supervised by our expert team.',
  'wholesale.process1Title': 'Raw Material Selection',
  'wholesale.process1Desc': 'High-quality yarns and natural fibers are carefully selected and subjected to quality tests.',
  'wholesale.process2Title': 'Weaving & Production',
  'wholesale.process2Desc': 'Carpets are produced with the combination of state-of-the-art machines and skilled hands.',
  'wholesale.process3Title': 'Dyeing & Coloring',
  'wholesale.process3Desc': 'Vibrant and permanent colors are achieved using eco-friendly dyes.',
  'wholesale.process4Title': 'Quality Control',
  'wholesale.process4Desc': 'Each carpet undergoes multi-stage quality tests and standards are verified.',
  'wholesale.process5Title': 'Packaging & Shipment',
  'wholesale.process5Desc': 'Products are safely packaged with special packaging and shipped worldwide.',

  'wholesale.typesLabel': 'Carpet Types',
  'wholesale.typesTitle': 'Differences Between Machine Carpet and Handmade Carpet',
  'wholesale.typesSubtitle': 'Two main production categories in our wholesale carpet sales: modern machine-made carpets and traditional handwoven carpets.',
  'wholesale.machineCarpetTitle': 'Machine Carpet',
  'wholesale.machineCarpetDesc': 'Machine carpets produced with high-tech weaving machines are the most preferred category in wholesale carpet sales. With standard sizes, wide color options and competitive prices, they are ideal for large volume orders. With daily production capacity of thousands of square meters, they offer fast delivery.',
  'wholesale.handCarpetTitle': 'Handmade Carpet',
  'wholesale.handCarpetDesc': 'Handwoven carpets crafted by master weavers stand out in the premium segment with their unique patterns and textures. Each one is a work of art; handmade carpets are preferred for hotels, boutique stores and special projects. Custom design and size options are available for wholesale handmade carpet orders.',
  'wholesale.tag.fast': 'Fast Production',
  'wholesale.tag.uniform': 'Standard Quality',
  'wholesale.tag.affordable': 'Competitive Price',
  'wholesale.tag.unique': 'Unique Design',
  'wholesale.tag.artisan': 'Handcrafted',
  'wholesale.tag.premium': 'Premium Segment',

  'wholesale.qualityLabel': 'Quality Control',
  'wholesale.qualityTitle': 'Quality Control in Carpet Production',
  'wholesale.qualitySubtitle': 'Multi-stage quality control processes applied in our wholesale carpet production guarantee that every product meets international standards.',
  'wholesale.quality1Title': 'Raw Material Analysis',
  'wholesale.quality1Desc': 'All yarns and fibers used in production are subjected to physical and chemical tests in accredited laboratories. Standards requiring OEKO-TEX certification are meticulously applied.',
  'wholesale.quality2Title': 'In-Process Control',
  'wholesale.quality2Desc': 'Instant quality controls are performed at weaving, dyeing and finishing stages. Color consistency, pattern precision and surface quality are continuously monitored.',
  'wholesale.quality3Title': 'Final Product Inspection',
  'wholesale.quality3Desc': 'Each completed carpet undergoes comprehensive final inspection for dimensional accuracy, surface defects and durability. Products that do not meet standards are not shipped.',
  'wholesale.quality4Title': 'International Certification',
  'wholesale.quality4Desc': 'With our ISO 9001 Quality Management System, OEKO-TEX Standard 100 and CE certificates, we provide international assurance in wholesale carpet export.',
  'wholesale.qualityBannerTitle': 'Zero Defect Policy',
  'wholesale.qualityBannerDesc': '100% quality assurance in every wholesale carpet order. We export with confidence backed by our international compliance certificates.',

  'wholesale.exportLabel': 'Logistics & Export',
  'wholesale.exportTitle': 'Logistics and Export Process',
  'wholesale.exportSubtitle': 'With our carpet export network extending from Gaziantep to the world, we deliver safely and on time to more than 50 countries.',
  'wholesale.exportMapTitle': 'Global Carpet Export Network',
  'wholesale.exportMapDesc': 'Wholesale carpet export to 50+ countries in Europe, Middle East, Asia and Africa',
  'wholesale.region.europe': 'Europe',
  'wholesale.region.middleEast': 'Middle East',
  'wholesale.region.asia': 'Asia',
  'wholesale.region.africa': 'Africa',
  'wholesale.logisticsTitle': 'Safe Logistics & Fast Delivery',
  'wholesale.logisticsDesc': 'Your wholesale carpet orders arrive safely with special packaging, insured cargo and door-to-door delivery options.',

  'wholesale.turkeyLabel': "Turkey's Power",
  'wholesale.turkeyTitle': "Turkey's Carpet Production Power",
  'wholesale.turkeyP1': 'Turkey, as a leader in world carpet exports, is a decisive force in the global market. Carpet production centers in Turkey, especially Gaziantep, contribute to the world economy with billions of dollars in annual export volume.',
  'wholesale.turkeyP2': "The Turkish carpet industry creates unique products by blending traditional craftsmanship with modern production technologies. Turkey's competitive price, high quality and wide design range in wholesale carpet production continues to be the first choice of global carpet wholesalers.",
  'wholesale.turkeyP3': 'As one of the leading representatives of this powerful industry, we continue our mission of bringing Turkish carpet art to the world with determination. We work every day to be Turkey\'s brand in carpet export.',
  'wholesale.turkeyRank': 'In World Carpet Export',
  'wholesale.turkeyFact1': 'World Carpet Export Share',
  'wholesale.turkeyFact2': 'Annual Export Value',
  'wholesale.turkeyFact3': 'Countries Exported',

  'wholesale.distLabel': 'Distribution',
  'wholesale.distTitle': 'Global Carpet Sales and Distribution System',
  'wholesale.distSubtitle': 'Strong business partnerships we have established with carpet wholesalers and distributors worldwide form the foundation of our global carpet sales.',
  'wholesale.dist1Title': 'Local Dealer Network',
  'wholesale.dist1Desc': 'We create a strong local sales network with more than 170 active dealers across Turkey. We offer exclusive pricing, marketing support and training programs to our dealers.',
  'wholesale.dist2Title': 'International Distributors',
  'wholesale.dist2Desc': 'We conduct global carpet sales through our authorized distributors in more than 50 countries. We offer customized trade conditions and logistics solutions for each region.',
  'wholesale.dist3Title': 'Corporate & Project Sales',
  'wholesale.dist3Desc': 'We produce special wholesale carpet solutions for hotels, shopping centers, offices and public projects. We guarantee competitive prices and fast delivery for large-volume projects.',

  'wholesale.faqLabel': 'FAQ',
  'wholesale.faqTitle': 'Frequently Asked Questions',
  'wholesale.faq1Q': 'What is the minimum order quantity in wholesale carpet production?',
  'wholesale.faq1A': 'The minimum quantity for wholesale carpet orders varies by collection and product type. For machine carpet orders, wholesale price advantages are generally offered for orders of 100 m² and above. Please contact our sales team for detailed information.',
  'wholesale.faq2Q': 'Which countries do you deliver to for carpet export?',
  'wholesale.faq2A': 'We export carpets to more than 50 countries including Europe, Middle East, Asia and Africa. Germany, France, UAE, Saudi Arabia, China and Japan are among our main export markets. Contact us for delivery conditions specific to your country.',
  'wholesale.faq3Q': 'What are the key differences between machine carpet and handmade carpet?',
  'wholesale.faq3A': 'Machine carpets are produced with high-speed weaving machines; they offer standard quality, fast delivery and competitive prices. Handmade carpets are hand-woven by master craftsmen; each is unique, requires longer production time and is in the premium price segment. We offer wide stock availability for both categories in wholesale carpet sales.',
  'wholesale.faq4Q': 'What are the payment terms for wholesale carpet orders?',
  'wholesale.faq4A': 'We offer flexible payment options for wholesale carpet purchases: additional discount for cash payment, 30-60-90 day deferred payment options and letter of credit for export orders. Special credit limits are granted to our long-term business partners.',
  'wholesale.faq5Q': 'Can I place a custom design wholesale carpet order?',
  'wholesale.faq5A': 'Yes, we can produce wholesale carpets in custom designs, colors and sizes for our corporate clients and large-volume buyers. Minimum order quantities apply for logo carpets and custom pattern and color combinations. Please contact our sales team to share your project details.',

  'wholesale.ctaTitle': 'Contact Us for Wholesale Carpet Orders',
  'wholesale.ctaDesc': 'As a carpet wholesaler, we offer reliable supply solutions worldwide. Contact us now for wholesale carpet sales, carpet export and distributorship.',

  // Gaziantep Carpet Page
  'gaziantepCarpet.heroLabel': 'Gaziantep Carpet Factory & Global Export',
  'gaziantepCarpet.heroTitle': 'Gaziantep Carpet — The Heart of Turkey\'s Carpet Production',
  'gaziantepCarpet.heroSubtitle': 'As a leading wholesale carpet manufacturer among Gaziantep carpet factories, we deliver your bulk carpet orders worldwide with high production capacity and strong logistics infrastructure. We export to 80+ countries as a carpet wholesaler.',
  'gaziantepCarpet.heroAlt': 'Gaziantep Carpet Factory',
  'gaziantepCarpet.ctaContact': 'Contact Us',
  'gaziantepCarpet.ctaCollections': 'Explore Collections',

  'gaziantepCarpet.stat1': 'Gaziantep Carpet Factories',
  'gaziantepCarpet.stat2': 'm² Annual Production',
  'gaziantepCarpet.stat3': 'Export Countries',
  'gaziantepCarpet.stat4': 'Years of Experience',

  'gaziantepCarpet.introLabel': 'Gaziantep Wholesale Carpet Production',
  'gaziantepCarpet.introTitle': 'Gaziantep Wholesale Carpet Production & Carpet Wholesaler',
  'gaziantepCarpet.introP1': 'Gaziantep is one of the largest carpet production centers in Turkey and the world. With over 500 carpet factories operating in the city and annual production exceeding 2 billion square meters, MONS HALI stands as a leading carpet wholesaler in this powerful ecosystem, providing uninterrupted quality supply to global buyers.',
  'gaziantepCarpet.introP2': 'Our Gaziantep carpet factory produces machine-made carpets, handmade carpets and custom-size carpets. Our wholesale carpet prices remain competitive thanks to our high production capacity and efficient logistics network. As a carpet manufacturer, we offer tailored solutions for every customer.',
  'gaziantepCarpet.introP3': 'As a wholesale carpet manufacturer, we regularly export to European, Middle Eastern and Asian markets. Our ISO 9001 certified production processes and OEKO-TEX compliant raw material usage meet international quality standards.',
  'gaziantepCarpet.badge1': 'Gaziantep Carpet Factory',
  'gaziantepCarpet.badge2': 'Wholesale Carpet Manufacturer',
  'gaziantepCarpet.badge3': 'ISO 9001 Certified',
  'gaziantepCarpet.isoCertified': 'Certified Production',

  'gaziantepCarpet.factoryBannerAlt': 'Gaziantep Carpet Factories',
  'gaziantepCarpet.factoryBannerTitle': 'Gaziantep Carpet Factories — World\'s Production Hub',
  'gaziantepCarpet.factoryBannerDesc': 'Thousands of square meters of carpet are produced daily at our modern production facilities in Gaziantep. We serve you with high capacity, fast delivery and competitive wholesale carpet prices.',

  'gaziantepCarpet.advLabel': 'Why Choose Us',
  'gaziantepCarpet.advTitle': 'Advantages of Our Gaziantep Carpet Factory',
  'gaziantepCarpet.advSubtitle': 'We differentiate ourselves from competitors with 6 key advantages as a carpet wholesaler and carpet manufacturer.',
  'gaziantepCarpet.adv1Title': 'High Production Capacity',
  'gaziantepCarpet.adv1Desc': 'With a daily production capacity of 50,000 m² at our Gaziantep factory, we fulfill large-volume wholesale carpet orders in a short time.',
  'gaziantepCarpet.adv2Title': 'Strong Logistics Infrastructure',
  'gaziantepCarpet.adv2Desc': 'Thanks to Gaziantep\'s strategic location and advanced logistics network, we provide fast and safe delivery to Europe, Middle East and Asia.',
  'gaziantepCarpet.adv3Title': 'Competitive Wholesale Carpet Prices',
  'gaziantepCarpet.adv3Desc': 'We offer the most competitive wholesale carpet prices in the market with our high production efficiency and raw material advantages.',
  'gaziantepCarpet.adv4Title': 'Wide Design Range',
  'gaziantepCarpet.adv4Desc': 'We meet the demands of every market with over 1,000 pattern and color options including modern, classic, ethnic and custom design carpets.',
  'gaziantepCarpet.adv5Title': 'International Quality Standards',
  'gaziantepCarpet.adv5Desc': 'We provide international assurance in wholesale carpet export with our ISO 9001, OEKO-TEX and CE certificates.',
  'gaziantepCarpet.adv6Title': '24/7 Customer Support',
  'gaziantepCarpet.adv6Desc': 'We provide 24/7 service for order tracking, technical support and export document preparation in wholesale carpet purchases.',

  'gaziantepCarpet.prodLabel': 'Product Categories',
  'gaziantepCarpet.prodTitle': 'Machine Carpet, Handmade Carpet and Custom Size Production',
  'gaziantepCarpet.prodSubtitle': 'Three main categories produced at our Gaziantep carpet factory: high-capacity machine carpet, premium handmade carpet and custom project carpets.',
  'gaziantepCarpet.prod1Title': 'Machine Carpet Production',
  'gaziantepCarpet.prod1Desc': 'Machine carpets produced with state-of-the-art weaving machines are the most preferred category in wholesale carpet sales. With high daily production capacity, standard quality and competitive wholesale carpet prices, they are ideal for large-volume orders.',
  'gaziantepCarpet.prod2Title': 'Handmade Carpet Production',
  'gaziantepCarpet.prod2Desc': 'Handwoven carpets crafted by master Gaziantep weavers stand out in the premium segment. Preferred for hotels, boutique stores and special projects, handmade carpets add value to every space with their unique patterns and textures.',
  'gaziantepCarpet.prod3Title': 'Custom Size Carpet Production',
  'gaziantepCarpet.prod3Desc': 'We produce carpets in custom sizes, colors and pattern combinations for corporate clients and large projects. We offer special wholesale carpet solutions for hotels, shopping malls, offices and public projects.',
  'gaziantepCarpet.tag.machine': 'Machine Carpet',
  'gaziantepCarpet.tag.bulk': 'Bulk Order',
  'gaziantepCarpet.tag.fast': 'Fast Delivery',
  'gaziantepCarpet.tag.handmade': 'Handwoven',
  'gaziantepCarpet.tag.premium': 'Premium',
  'gaziantepCarpet.tag.unique': 'Unique Design',
  'gaziantepCarpet.tag.modern': 'Modern Design',
  'gaziantepCarpet.tag.custom': 'Custom Production',
  'gaziantepCarpet.tag.export': 'Export',

  'gaziantepCarpet.logisticsBannerAlt': 'Carpet Logistics and Export',
  'gaziantepCarpet.logisticsBannerTitle': 'Export & Logistics — From Gaziantep to the World',
  'gaziantepCarpet.logisticsBannerDesc': 'Thanks to Gaziantep\'s strategic location and advanced road and air connections, we deliver your wholesale carpet orders to Europe, Middle East and Asia quickly and safely.',

  'gaziantepCarpet.exportLabel': 'Global Export',
  'gaziantepCarpet.exportTitle': 'Carpet Sales from Turkey to the World',
  'gaziantepCarpet.exportSubtitle': 'We export wholesale carpets from our Gaziantep carpet factory to more than 80 countries. We work with reliable business partners on all continents, especially in Europe and the Middle East.',
  'gaziantepCarpet.exportMapTitle': 'Carpet Export from Gaziantep to 80+ Countries',
  'gaziantepCarpet.exportMapDesc': 'Wholesale carpet sales with our strong distributor network in Europe, Middle East, Asia and Africa',
  'gaziantepCarpet.market1': 'European Market',
  'gaziantepCarpet.market2': 'Middle East Market',
  'gaziantepCarpet.market3': 'Asian Market',
  'gaziantepCarpet.market4': 'African Market',

  'gaziantepCarpet.whyLabel': 'Why Gaziantep',
  'gaziantepCarpet.whyTitle': 'Gaziantep Carpet Factories — Turkey\'s Production Power',
  'gaziantepCarpet.whyP1': 'Gaziantep is a giant production center that single-handedly accounts for approximately 80% of Turkey\'s carpet exports. With over 500 carpet factories, more than 50,000 employees and an annual export volume of $3 billion, Gaziantep is at the center of world carpet trade.',
  'gaziantepCarpet.whyP2': 'Gaziantep carpet factories have a complete ecosystem from raw material supply to production technology, from logistics to export infrastructure. This powerful infrastructure keeps wholesale carpet prices competitive and shortens delivery times.',
  'gaziantepCarpet.whyP3': 'Operating within this powerful ecosystem as MONS HALI, we offer the best price-quality balance to global buyers with our wholesale carpet manufacturer identity. We are your reliable solution partner in Gaziantep wholesale carpet production.',
  'gaziantepCarpet.whyFact1': 'Gaziantep Carpet Factories',
  'gaziantepCarpet.whyFact2': 'Turkey Carpet Export Share',
  'gaziantepCarpet.whyFact3': 'Annual Export Value',
  'gaziantepCarpet.whyRank': 'In Turkey Carpet Export',

  'gaziantepCarpet.wholesaleLabel': 'Wholesale Carpet Sales',
  'gaziantepCarpet.wholesaleTitle': 'Carpet Wholesaler & Wholesale Carpet Price Advantages',
  'gaziantepCarpet.wholesaleSubtitle': 'We are the trusted supplier of global buyers with our advantageous prices and flexible payment terms in Gaziantep wholesale carpet sales.',
  'gaziantepCarpet.wholesaleP1': 'The wholesale carpet prices we offer as a carpet wholesaler are at the most competitive levels in the market thanks to our high production capacity and raw material advantages. Special wholesale price advantages are offered for orders of 100 m² and above.',
  'gaziantepCarpet.wholesaleP2': 'Flexible payment options, special credit limits and letter of credit for export orders are available for Gaziantep wholesale carpet purchases. Special pricing and priority production planning are made for long-term business partners.',
  'gaziantepCarpet.wholesaleP3': 'As a wholesale carpet manufacturer, we can produce wholesale carpets in custom designs, colors and sizes for our corporate clients. We produce special solutions for logo carpets, hotel projects and large-volume commercial orders.',
  'gaziantepCarpet.wholesaleFeature1': 'Wholesale price advantage from minimum 100 m² orders',
  'gaziantepCarpet.wholesaleFeature2': 'Flexible payment: 30-60-90 day deferred options',
  'gaziantepCarpet.wholesaleFeature3': 'Letter of credit and insured cargo for export orders',
  'gaziantepCarpet.wholesaleFeature4': 'Custom design and logo carpet production',

  'gaziantepCarpet.faqLabel': 'FAQ',
  'gaziantepCarpet.faqTitle': 'Frequently Asked Questions',
  'gaziantepCarpet.faq1Q': 'What is the minimum quantity for Gaziantep wholesale carpet orders?',
  'gaziantepCarpet.faq1A': 'The minimum quantity for Gaziantep wholesale carpet orders varies by product type. For machine carpet orders, wholesale price advantages are offered for orders of 100 m² and above. Separate minimum quantities apply for handmade and custom production orders.',
  'gaziantepCarpet.faq2Q': 'Which countries do you export to from the Gaziantep carpet factory?',
  'gaziantepCarpet.faq2A': 'We export wholesale carpets from our Gaziantep carpet factory to more than 80 countries including Europe, Middle East, Asia and Africa. Germany, France, UAE, Saudi Arabia, China and Japan are among our main export markets.',
  'gaziantepCarpet.faq3Q': 'How are wholesale carpet prices determined?',
  'gaziantepCarpet.faq3A': 'Wholesale carpet prices are determined by order quantity, product type, pattern complexity and delivery conditions. Thanks to our production advantages in Gaziantep, we can offer the most competitive wholesale carpet prices in the market.',
  'gaziantepCarpet.faq4Q': 'Do you produce custom design carpets?',
  'gaziantepCarpet.faq4A': 'Yes, we produce wholesale carpets in custom designs, colors and sizes for our corporate clients. Minimum order quantities apply for logo carpets, hotel projects and custom pattern combinations.',
  'gaziantepCarpet.faq5Q': 'How does logistics work for carpet export from Gaziantep?',
  'gaziantepCarpet.faq5A': 'Thanks to Gaziantep\'s strategic location and advanced logistics infrastructure, we deliver your wholesale carpet orders worldwide by road, sea and air. Special packaging, insured cargo and door-to-door delivery options are available.',

  'gaziantepCarpet.ctaTitle': 'Contact Us for Gaziantep Wholesale Carpet Orders',
  'gaziantepCarpet.ctaDesc': 'Contact us now for wholesale carpet sales, wholesale carpet export and custom production from our Gaziantep carpet factory. Competitive price and fast delivery guarantee.',

  'product.carpet001.name': 'Grey Herringbone Carpet',
  'product.carpet001.description': 'Elegant grey herringbone pattern carpet that adds sophistication to your spaces with modern design.',
  'product.carpet002.name': 'Beige Herringbone Carpet',
  'product.carpet002.description': 'Classic herringbone carpet in warm natural beige tones that suits every space.',
  'product.carpet003.name': 'Anthracite Herringbone Carpet',
  'product.carpet003.description': 'Carpet with deep sophisticated anthracite color that perfectly complements modern spaces.',
  'product.carpet004.name': 'Cream Herringbone Carpet',
  'product.carpet004.description': 'Elegant cream herringbone carpet ideal for bright and airy spaces.',
  'product.carpet005.name': 'Brown Herringbone Carpet',
  'product.carpet005.description': 'Elegant carpet in warm brown tones suitable for rustic and modern spaces.',
  'product.carpet006.name': 'Navy Blue Herringbone Carpet',
  'product.carpet006.description': 'Elegant carpet with deep navy blue color offering a luxurious and sophisticated look.',
  'product.carpet007.name': 'Green Herringbone Carpet',
  'product.carpet007.description': 'Carpet creating a fresh and peaceful atmosphere with natural green tones.',
  'product.carpet008.name': 'Pink Herringbone Carpet',
  'product.carpet008.description': 'Carpet adding a romantic and elegant touch with soft pink tones.',
  'product.carpet009.name': 'Burgundy Herringbone Carpet',
  'product.carpet009.description': 'Special design carpet for classic and luxurious spaces with rich burgundy color.',
  'product.carpet010.name': 'Turquoise Herringbone Carpet',
  'product.carpet010.description': 'Carpet adding dynamism to modern and energetic spaces with vibrant turquoise color.',
  'product.carpet011.name': 'Mustard Yellow Herringbone Carpet',
  'product.carpet011.description': 'Carpet creating a cheerful and modern atmosphere with warm mustard yellow tone.',
  'product.carpet012.name': 'Orange Herringbone Carpet',
  'product.carpet012.description': 'Special design carpet for dynamic and bold spaces with energetic orange color.',
  'product.carpet013.name': 'Purple Herringbone Carpet',
  'product.carpet013.description': 'Special carpet suitable for sophisticated and luxurious spaces with elegant purple tones.',
  'product.carpet014.name': 'Smoke Grey Herringbone Carpet',
  'product.carpet014.description': 'Versatile carpet that adapts to every space with neutral smoke grey tone.',
  'product.carpet015.name': 'Stone Grey Herringbone Carpet',
  'product.carpet015.description': 'Carpet suitable for minimalist and modern spaces with natural stone grey tone.',
  'product.carpet016.name': 'Ecru Herringbone Carpet',
  'product.carpet016.description': 'Elegant carpet that adapts to classic and modern spaces with warm ecru tone.',
  'product.carpet017.name': 'Mink Herringbone Carpet',
  'product.carpet017.description': 'Premium carpet for luxurious and elegant spaces with stylish mink color.',
  'product.carpet018.name': 'Black Herringbone Carpet',
  'product.carpet018.description': 'Sophisticated touch for modern and minimalist spaces with classic black color.',
  'product.carpet019.name': 'White Herringbone Carpet',
  'product.carpet019.description': 'Ideal minimalist carpet for bright and airy spaces with pure white color.',
  'product.carpet020.name': 'Silver Grey Herringbone Carpet',
  'product.carpet020.description': 'Carpet adding glamour to luxurious and modern spaces with shimmering silver grey tone.',
  'product.carpet021.name': 'Golden Yellow Herringbone Carpet',
  'product.carpet021.description': 'Prestigious carpet for showy and luxurious spaces with rich golden yellow tone.',
  'product.carpet022.name': 'Bronze Herringbone Carpet',
  'product.carpet022.description': 'Carpet adding timeless elegance to classic and modern spaces with warm bronze tone.',
  'product.carpet023.name': 'Copper Herringbone Carpet',
  'product.carpet023.description': 'Carpet offering a dynamic look for modern and energetic spaces with vibrant copper color.',
  'product.carpet024.name': 'Olive Green Herringbone Carpet',
  'product.carpet024.description': 'Carpet suitable for peaceful and organic spaces with natural olive green tone.',
  'product.carpet025.name': 'Grass Green Herringbone Carpet',
  'product.carpet025.description': 'Carpet adding freshness to lively and energetic spaces with fresh grass green tone.',
  'product.carpet026.name': 'Sea Blue Herringbone Carpet',
  'product.carpet026.description': 'Carpet suitable for peaceful and coastal themed spaces with calm sea blue tone.',
  'product.carpet027.name': 'Sky Blue Herringbone Carpet',
  'product.carpet027.description': 'Carpet adding a fresh touch to bright and airy spaces with light sky blue tone.',
  'product.carpet028.name': 'Lavender Purple Herringbone Carpet',
  'product.carpet028.description': 'Elegant carpet suitable for romantic and peaceful spaces with soft lavender purple tone.',
  'product.carpet029.name': 'Coral Pink Herringbone Carpet',
  'product.carpet029.description': 'Carpet adding dynamism to energetic and cheerful spaces with vibrant coral pink tone.',
  'product.carpet030.name': 'Peach Herringbone Carpet',
  'product.carpet030.description': 'Carpet adding a comfortable atmosphere to warm and inviting spaces with sweet peach color.',

  'product.feature.material': 'Material',
  'product.feature.production': 'Production',
  'product.feature.pileHeight': 'Pile Height',
  'product.feature.base': 'Base',

  'product.value.polypropylene': 'Polypropylene',
  'product.value.flatWeave': 'Flat Weave',
  'product.value.machineWoven': 'Machine Woven',
  'product.value.jute': 'Jute',
  'product.value.lowPile': 'Low Pile',
  'product.value.mediumPile': 'Medium Pile',
  'product.value.highPile': 'High Pile',

  'product.modal.prevProduct': 'Previous Product',
  'product.modal.nextProduct': 'Next Product',
  'product.modal.sizesTitle': 'Sizes & Dimensions',
  'product.modal.featuresTitle': 'Product Features',
  'product.modal.productCode': 'Product Code',
  'product.modal.backToPage': 'Back to Page',
  'product.modal.zoomHint': 'Click on the image to zoom in',
  'product.modal.fullscreenHint': 'Double click to zoom · Scroll to zoom · Drag to pan',
  'product.modal.fullscreen': 'Fullscreen',

  // Home Blog Posts
  'blog.home101.title': 'Sustainability in the Textile Industry',
  'blog.home101.excerpt': 'Detailed information about our eco-friendly production processes and sustainable textile approach.',
  'blog.home101.date': 'March 15, 2024',
  'blog.home101.readTime': '5 min',
  'blog.home102.title': '2024 Textile Trends',
  'blog.home102.excerpt': 'Expert opinions and forecasts on new season textile trends and color palettes.',
  'blog.home102.date': 'March 10, 2024',
  'blog.home102.readTime': '7 min',
  'blog.home103.title': 'Our Quality Control Processes',
  'blog.home103.excerpt': 'The meticulous control processes we apply to ensure our products meet the highest quality standards.',
  'blog.home103.date': 'March 5, 2024',
  'blog.home103.readTime': '6 min',

  // Collections Hero Slider
  'collectionsHero.slide1.tag': 'Wholesale Carpet Sales',
  'collectionsHero.slide1.title': 'Premium Carpet\nCollections',
  'collectionsHero.slide1.subtitle': 'Wholesale carpet production from Gaziantep to the world, exporting to 50+ countries',
  'collectionsHero.slide1.stat1Label': 'Export Countries',
  'collectionsHero.slide1.stat2Label': 'Years of Experience',
  'collectionsHero.slide2.tag': 'Wholesale Carpet Production',
  'collectionsHero.slide2.title': 'Wholesale Carpet\nSales Center',
  'collectionsHero.slide2.subtitle': 'Daily production of thousands of m² of carpet in our ISO 9001 certified facilities',
  'collectionsHero.slide2.stat1Label': 'Special Collections',
  'collectionsHero.slide2.stat2Label': 'Active Dealers',
  'collectionsHero.slide3.tag': 'Carpet Factory\nOpening to the World',
  'collectionsHero.slide3.title': 'Carpet Factory\nOpening to the World',
  'collectionsHero.slide3.subtitle': 'Add value to your living spaces with modern designs and traditional craftsmanship',
  'collectionsHero.slide3.stat1Label': 'm² Annual Production',
  'collectionsHero.slide3.stat2Label': 'Unique Patterns',
  'collectionsHero.cta.explore': 'Explore Collections',
  'collectionsHero.cta.price': 'Get Wholesale Price',
  'collectionsHero.aria.slider': 'Wholesale Carpet Collections Hero Slider',
  'collectionsHero.aria.slide': 'Slide',
  'collectionsHero.aria.prev': 'Previous slide',
  'collectionsHero.aria.next': 'Next slide',
  'collectionsHero.aria.goto': 'Go to collections',
};

export default common;